import React, { useMemo, useRef } from 'react';
import FlyOutMenu from '../../../../core/components/FlyOutMenu';
import FormEdit from '../../../../core/components/form/FormEdit';
import FormSubmit from '../../../../core/components/form/FormSubmit';
import Button from '../../../../core/components/Button';
import Dialog from '../../../../core/components/Dialog';
import ValidInputFile from '../../../../core/components/validation/ValidInputFile';

import { usePayorListImport } from './usePayorListImport';

const PayorImportFlyOut = (): JSX.Element => {
    const { state, submit, cancel, setFile } = usePayorListImport();
    const dialogRef = useRef<HTMLDivElement>(null);

    if (!state.showing) {
        return <></>;
    }

    const disabled = state.importing || state.confirming;

    return (
        <>
            <div ref={dialogRef}>
                <ConfirmDialog />
            </div>
            <FlyOutMenu
                title="Import Excluded Payors"
                isOpen={true}
                onClose={cancel}
                width={530}
                ignoreClickRef={dialogRef}
            >
                <div className="mfr-fly-out-menu">
                    <FormEdit
                        formName="payor-list-import"
                        cssName="mfr-restrictions-edit-form"
                    >
                        <ValidInputFile
                            prop={state.ImportFile}
                            onChange={setFile}
                            disabled={disabled}
                        />
                        <div
                            className="mfr-help-text"
                            style={{ fontSize: '12px', color: '#666', marginTop: '8px' }}
                        >
                            <p style={{ marginBottom: '4px' }}>
                                <strong>File Format:</strong> Pipe-delimited (|) file (.csv or .txt)
                            </p>
                            <p style={{ marginBottom: '4px' }}>
                                <strong>Columns:</strong> BIN | PCN | GROUP | TYPE | STATE | DESCRIPTION
                            </p>
                            <p style={{ marginBottom: '4px' }}>
                                <strong>Required:</strong> BIN (6 digits), TYPE (FFS or Managed)
                            </p>
                            <p style={{ marginBottom: '0' }}>
                                <strong>Optional:</strong> PCN, GROUP, STATE, DESCRIPTION
                            </p>
                        </div>
                        <FormSubmit>
                            <Button
                                disabled={state.importing}
                                onClick={(): void => submit()}
                            >
                                {state.importing ? 'IMPORTING...' : 'IMPORT'}
                            </Button>
                            <span>
                                <Button
                                    cssName="btn-cancel"
                                    onClick={cancel}
                                    disabled={state.importing}
                                >
                                    CANCEL
                                </Button>
                            </span>
                        </FormSubmit>
                    </FormEdit>
                </div>
            </FlyOutMenu>
        </>
    );
};

const ConfirmDialog = (): JSX.Element => {
    const { state, submit, cancel } = usePayorListImport();

    const title = 'Import Excluded Payors';
    const msg = 'Confirm you wish to import these payors?';

    const confirmOptions = useMemo(
        () => [
            {
                label: 'OK',
                onClick: (): void => submit(true),
            },
            {
                label: 'CANCEL',
                onClick: (): void => cancel(),
                cssName: 'btn-cancel',
            },
        ],
        [submit, cancel],
    );

    if (!state.confirming) {
        return <></>;
    }

    return (
        <Dialog
            open={true}
            setOpen={(): void => cancel()}
            title={title}
            message={msg}
            actions={confirmOptions}
        />
    );
};

export default PayorImportFlyOut;
